export const CIRCLES_OPTIONS_FETCH = 'circles/options/fetch';
export const CIRCLES_FETCH = 'circles/fetch';
export const CIRCLES_CONTACTS_FETCH = 'circles/contacts/fetch';
